import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import flaskServer from '../config/flaskserver';
import Typography from '@mui/material/Typography';

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isValidToken, setIsValidToken] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    useEffect(() => {
        const checkTokenValidity = async () => {
            try {
                const response = await axios.get(`${flaskServer.flaskServerIP}/verify-pwdtoken/${token}`);
                if (response.data.valid) {
                    setIsValidToken(true);
                } else {
                    setIsValidToken(false);
                    setSnackbarMessage('O token de recuperação de senha expirou ou é inválido', 'error');
                }
            } catch (error) {
                setIsValidToken(false);
                setSnackbarMessage('O token de recuperação de senha expirou ou é inválido');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                setTimeout(() => {
                    navigate('/login');
                }, 30000); // Redirecionar após 30 segundos
            }
        };

        checkTokenValidity();
    }, [token, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const response = await axios.post(`${flaskServer.flaskServerIP}/reset-password/${token}`, {
                new_password: newPassword
            });
            console.log('response')
            console.log(response)
            console.log(response.data)
            setSnackbarMessage(response.data.message);
            setSnackbarSeverity('success');
            setSnackbarOpen(true);

            setTimeout(() => {
                navigate('/login');
            }, 3000); // Redirecionar após 3 segundos
        } catch (error) {
            console.log(error)
            let errorMessage = 'Erro ao redefinir senha';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    return (
        <Container component="main" maxWidth="xs" style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="reset-password-container">
                {isValidToken ? (
                    <form onSubmit={handleSubmit} className="reset-password-form">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="newPassword"
                                    label="Nova Senha"
                                    type="password"
                                    id="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="confirmPassword"
                                    label="Confirmar Nova Senha"
                                    type="password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            style={{ marginTop: '20px' }}
                        >
                            Redefinir Senha
                        </Button>
                    </form>
                ) : (
                    <Typography variant="h6" color="error">
                        {snackbarMessage}
                    </Typography>
                )}
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        </Container>
    );
};

export default ResetPassword;
